// S1: Gerätekennung je Konto im Browser (localStorage "tn_geraete"), rein, ohne Importe.
// Nur Verwaltung bekommt vom Server einen Merker; logout löscht ihn bewusst nicht.
export const GERAETE_SCHLUESSEL = 'tn_geraete';
export const GERAETE_MAX = 10;

const schluessel = (email) => String(email || '').trim().toLowerCase();
const standardSpeicher = () => (typeof localStorage === 'undefined' ? null : localStorage);

const lesen = (speicher) => {
  const obj = JSON.parse(speicher.getItem(GERAETE_SCHLUESSEL) || '{}');
  return obj && typeof obj === 'object' && !Array.isArray(obj) ? obj : {};
};

export function merkerFuer(email, speicher = standardSpeicher()) {
  try {
    const m = lesen(speicher)[schluessel(email)];
    return typeof m === 'string' && m ? m : null;
  } catch {
    return null;
  }
}

export function merkerSpeichern(email, merker, speicher = standardSpeicher()) {
  const k = schluessel(email);
  if (!k || !merker || typeof merker !== 'string') return;
  try {
    const obj = lesen(speicher);
    delete obj[k];
    obj[k] = merker;
    const reihenfolge = Object.keys(obj);
    while (reihenfolge.length > GERAETE_MAX) delete obj[reihenfolge.shift()];
    speicher.setItem(GERAETE_SCHLUESSEL, JSON.stringify(obj));
  } catch {
    /* privater Modus: dann eben ohne Merker */
  }
}
